import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { salvar, getLista } from './textoActions';

class TextoInput extends Component {

	state = {
		valor: ''
	}

    componentWillMount() {
		if (this.props.sessao.administrador) {
        	this.props.getLista();
		}
    }

    render() {
		if (this.props.sessao.administrador) {
			return (
				<div class='input-group input-group-sm'>
					<textarea
						type='text'
						class='form-control'
						placeholder='Digite aqui para alterar o texto'
						value={this.state.valor}
						onChange={data => {
							this.setState({
								...this.state,
								valor: data.target.value
							});
						}} />
					<span class='input-group-append'>
						<button 
							type='button' 
							class='btn btn-info btn-flat'
							onClick={() => {
								this.props.salvar({
									chave: this.props.chave,
									valor: this.state.valor
								});
								this.setState({
									...this.state,
									valor: ''
								});
							}}>Salvar</button>
					</span>
				</div>
			);
		}

		return null;
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	salvar, getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(TextoInput);
